const c = ":host{display:inline-block;position:relative}";
class h extends HTMLElement {
  constructor() {
    super(), this._isOpen = !1, this._onScrollBound = null, this._onResizeBound = null, this._pendingPositionUpdate = null, this.GAP = 4, this._shadow = this.attachShadow({ mode: "open" }), this._handleOutsideClick = this._onOutsideClick.bind(this), this._handleEscape = this._onEscape.bind(this), this._onTriggerClickBound = this._onTriggerClick.bind(this), this._onItemSelectBound = this._onItemSelect.bind(this), this._render();
  }
  static get observedAttributes() {
    return ["open"];
  }
  connectedCallback() {
    this.addEventListener("sl-dropdown-trigger-click", this._onTriggerClickBound), this.addEventListener("sl-item-select", this._onItemSelectBound), document.addEventListener("click", this._handleOutsideClick), document.addEventListener("keydown", this._handleEscape), this._onScrollBound = this._schedulePositionUpdate.bind(this), this._onResizeBound = this._schedulePositionUpdate.bind(this), window.addEventListener("scroll", this._onScrollBound, { capture: !0, passive: !0 }), window.addEventListener("resize", this._onResizeBound, { passive: !0 });
  }
  disconnectedCallback() {
    this.removeEventListener("sl-dropdown-trigger-click", this._onTriggerClickBound), this.removeEventListener("sl-item-select", this._onItemSelectBound), document.removeEventListener("click", this._handleOutsideClick), document.removeEventListener("keydown", this._handleEscape), this._onScrollBound && window.removeEventListener("scroll", this._onScrollBound, { capture: !0 }), this._onResizeBound && window.removeEventListener("resize", this._onResizeBound), this._pendingPositionUpdate !== null && cancelAnimationFrame(this._pendingPositionUpdate);
  }
  attributeChangedCallback(e, t, s) {
    t !== s && e === "open" && (this._isOpen = s !== null, this._syncContent());
  }
  get open() {
    return this._isOpen;
  }
  set open(e) {
    e ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  _onTriggerClick() {
    this._isOpen ? this._close() : this._open();
  }
  _onItemSelect(e) {
    const t = e;
    this._close(), this.dispatchEvent(new CustomEvent("select", {
      bubbles: !0,
      composed: !0,
      detail: { value: t.detail?.value }
    }));
  }
  _onOutsideClick(e) {
    e.composedPath().includes(this) || this._close();
  }
  _onEscape(e) {
    e.key === "Escape" && this._isOpen && this._close();
  }
  _open() {
    this._isOpen = !0, this._syncContent(), requestAnimationFrame(() => {
      this._positionContent();
    }), this.dispatchEvent(new CustomEvent("open", { bubbles: !0, composed: !0 }));
  }
  _close() {
    this._isOpen && (this._isOpen = !1, this._syncContent(), this._clearContentPosition(), this.dispatchEvent(new CustomEvent("close", { bubbles: !0, composed: !0 })));
  }
  // px, equivalent to 0.25rem
  _getContent() {
    return this.querySelector(":scope > sl-dropdown-menu-content");
  }
  _positionContent() {
    const e = this._getContent();
    if (!e || !this._isOpen || !e.hasAttribute("open")) return;
    const t = this.getBoundingClientRect();
    if (t.width === 0 && t.height === 0) {
      requestAnimationFrame(() => this._positionContent());
      return;
    }
    const s = e.scrollHeight || 200, d = e.scrollWidth || 200, r = window.innerHeight - t.bottom - this.GAP, a = t.top - this.GAP;
    let l;
    r >= s ? l = t.bottom + this.GAP : a >= s ? l = t.top - s - this.GAP : l = t.bottom + this.GAP;
    let o = t.left;
    o + d > window.innerWidth - 8 && (o = Math.max(8, window.innerWidth - d - 8)), o = Math.max(8, o);
    const n = e;
    n.style.position = "fixed", n.style.top = `${l}px`, n.style.left = `${o}px`, n.style.bottom = "auto", n.style.right = "auto", n.style.margin = "0";
  }
  _clearContentPosition() {
    const e = this._getContent();
    if (!e) return;
    const t = e;
    t.style.position = "", t.style.top = "", t.style.left = "", t.style.bottom = "", t.style.right = "", t.style.margin = "";
  }
  _schedulePositionUpdate() {
    this._isOpen && this._pendingPositionUpdate === null && (this._pendingPositionUpdate = requestAnimationFrame(() => {
      this._pendingPositionUpdate = null, this._isOpen && this._positionContent();
    }));
  }
  _syncContent() {
    const e = this.querySelector("sl-dropdown-menu-content");
    e && (this._isOpen ? e.setAttribute("open", "") : e.removeAttribute("open"));
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${c}</style>
      <slot></slot>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-dropdown-menu") && customElements.define("sl-dropdown-menu", h);
const u = ":host{display:contents}";
class p extends HTMLElement {
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._onClickBound = this._onClick.bind(this), this._render();
  }
  connectedCallback() {
    this.addEventListener("click", this._onClickBound);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClickBound);
  }
  _onClick(e) {
    e.stopPropagation(), this.dispatchEvent(new CustomEvent("sl-dropdown-trigger-click", {
      bubbles: !0,
      composed: !0
    }));
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${u}</style>
      <slot></slot>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-dropdown-menu-trigger") && customElements.define("sl-dropdown-menu-trigger", p);
const m = ":host{display:none;position:absolute;top:calc(100% + 0.25rem);left:0;z-index:var(--sl-z-dropdown,1000);min-width:8rem;max-width:min(20rem,calc(100vw - 2rem));overflow:hidden;border-radius:var(--sl-radius-md);border:1px solid hsl(var(--sl-hsl-border));background-color:hsl(var(--sl-hsl-popover));color:hsl(var(--sl-hsl-popover-foreground));box-shadow:var(--sl-shadow-md);animation:sl-dropdown-fade-in var(--sl-transition-fast) ease-out}:host([open]){display:block}.sl-dropdown-menu__list{padding:var(--sl-spacing-1)}@keyframes sl-dropdown-fade-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}";
class _ extends HTMLElement {
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  get open() {
    return this.hasAttribute("open");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${m}</style>
      <div class="sl-dropdown-menu__list" role="menu">
        <slot></slot>
      </div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-dropdown-menu-content") && customElements.define("sl-dropdown-menu-content", _);
const b = ":host{display:block}.sl-dropdown-menu__item{display:flex;align-items:center;width:100%;padding:var(--sl-spacing-2) var(--sl-spacing-3);border-radius:var(--sl-radius-sm);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);color:hsl(var(--sl-hsl-foreground));cursor:pointer;user-select:none;outline:none;transition:background-color var(--sl-transition-fast);box-sizing:border-box}.sl-dropdown-menu__item:hover:not(.sl-dropdown-menu__item--disabled),.sl-dropdown-menu__item:focus:not(.sl-dropdown-menu__item--disabled){background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-dropdown-menu__item--disabled{pointer-events:none;opacity:0.5;cursor:not-allowed}";
class v extends HTMLElement {
  static get observedAttributes() {
    return ["disabled", "value", "label"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._onClickBound = this._onClick.bind(this), this._onKeydownBound = this._onKeydown.bind(this), this._render();
  }
  connectedCallback() {
    this.addEventListener("click", this._onClickBound), this.addEventListener("keydown", this._onKeydownBound);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onClickBound), this.removeEventListener("keydown", this._onKeydownBound);
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(e) {
    e ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get value() {
    return this.getAttribute("value") || "";
  }
  set value(e) {
    this.setAttribute("value", e);
  }
  get label() {
    return this.getAttribute("label") || "";
  }
  set label(e) {
    this.setAttribute("label", e);
  }
  _onClick(e) {
    if (this.disabled) {
      e.stopPropagation();
      return;
    }
    this.dispatchEvent(new CustomEvent("sl-item-select", {
      bubbles: !0,
      composed: !0,
      detail: { value: this.value }
    }));
  }
  _onKeydown(e) {
    (e.key === "Enter" || e.key === " ") && !this.disabled && (e.preventDefault(), this.dispatchEvent(new CustomEvent("sl-item-select", {
      bubbles: !0,
      composed: !0,
      detail: { value: this.value }
    })));
  }
  _render() {
    const e = ["sl-dropdown-menu__item"];
    this.disabled && e.push("sl-dropdown-menu__item--disabled");
    const t = this.label ? this.label : "<slot></slot>";
    this._shadow.innerHTML = `
      <style>${b}</style>
      <div
        class="${e.join(" ")}"
        role="menuitem"
        tabindex="${this.disabled ? "-1" : "0"}"
        aria-disabled="${this.disabled}"
      >${t}</div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-dropdown-menu-item") && customElements.define("sl-dropdown-menu-item", v);
const w = ":host{display:block}.sl-dropdown-menu__separator{height:1px;margin:var(--sl-spacing-1) calc(var(--sl-spacing-1) * -1);background-color:hsl(var(--sl-hsl-muted))}";
class g extends HTMLElement {
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${w}</style>
      <div class="sl-dropdown-menu__separator" role="separator"></div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-dropdown-menu-separator") && customElements.define("sl-dropdown-menu-separator", g);
export {
  _ as SlDropdownMenuContentElement,
  h as SlDropdownMenuElement,
  v as SlDropdownMenuItemElement,
  g as SlDropdownMenuSeparatorElement,
  p as SlDropdownMenuTriggerElement
};
//# sourceMappingURL=sl-dropdown-menu.js.map
